import script from "./SettingsDocuments.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsDocuments.vue?vue&type=script&setup=true&lang=js"

import "./SettingsDocuments.vue?vue&type=style&index=0&id=17160938&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17160938"]])

export default __exports__